import moment from 'moment'
import { isToday } from './utils'

moment.locale('es')

// * Return info by status document
export const docStatus = value => {
  const status = {
    VAL: { icon: 'ShieldIcon', color: 'primary', text: 'Documento validado por SICyT' },
    AUT: { icon: 'CheckCircleIcon', color: 'success', text: 'Documento autorizado por control escolar' },
    PEND: { icon: 'AlertCircleIcon', color: 'warning', text: 'Documento pendiente de revisión' },
    CAN: { icon: 'XCircleIcon', color: 'danger', text: 'Documento rechazado por control escolar' },
  }

  return status[value] || {}
}

// * Return hexadecimal color to rgb
export const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  if (alpha) return `rgba(${r}, ${g}, ${b}, ${alpha})`
  return `rgb(${r}, ${g}, ${b})`
}

// * Return variant by priority (notification)
export const notificationPriority = priority => {
  const color = {
    ALTA: 'danger',
    MEDIA: 'warning',
    BAJA: 'success',
  }

  return color[priority] || 'secondary'
}

//* Return description for each type of seriacion
export const seriacionTipo = tipo => {
  const type = {
    MP: 'Estar cursando en el mismo periodo',
    AP: 'Haberla aprobado en período anterior',
  }

  return type[tipo] || tipo
}

//* Return las time updated => return a string like this: 'hoy a las 16:04'
export const lastUpdate = () => moment().calendar()

//* Return a date formated => string like this: '17 de mayo de 2021'
export const timestampToDate = (timestamp, format = 'LL') => {
  if (format === 'unformated' || format === 'undefined' || !format) return new Date(timestamp * 1000)
  return moment.unix(timestamp).format(format)
}

//* RETURN NAME FOR EACH MODALITY [PRESENCIAL | EN LÍNEA | REMOTO EN VIVO | EN PLATAFORMA SIN ASESOR]
export const nombreModalidad = modalidad => {
  const modalidades = {
    EL: 'En línea',
    PR: 'Presencial',
    CPSA: 'En plataforma sin asesor',
    CPCA: 'En plataforma con asesor',
    RV: 'Remoto en vivo',
    SR: 'Sesión remota',
  }

  return modalidades[modalidad] || modalidad
}

/*
* Return type and color of status in orden
* by dny
*/
// export const frmstatus = [{
//   ACT: 'Activo', AUT: 'Autorizado', CAN: 'Cancelado', COM: 'Completado',
// },
// {
//   ACT: 'light-warning', AUT: 'light-success', CAN: 'light-danger', COM: 'light-completo',
// }]

/**
 * * frmstatus
 * Return type and color of status in orden
 * @param {value} valor de status en pagare
 * @returns properties for b-badge
 */
export const frmstatus = value => {
  const status = {
    ACT: { icon: 'ActivityIcon', color: 'light-warning', text: 'Activo' },
    COM: { icon: 'CheckSquareIcon', color: 'light-completo', text: 'Completado' },
    AUT: { icon: 'CheckIcon', color: 'light-success', text: 'Autorizado' },
    CAN: { icon: 'XCircleIcon', color: 'light-danger', text: 'Cancelado' },
    PND: { icon: 'ActivityIcon', color: 'light-warning', text: 'Pendiente' },
    PAG: { icon: 'CheckSquareIcon', color: 'light-completo', text: 'Pagado' },
  }

  return status[value] || {}
}

export const frmAbonos = n => {
  const today = new Date()
  // Asegurarnos de que `n.pagos` siempre tenga un valor numérico válido.
  const pagos = Number(n.pagos) || 0

  let check = {}

  if (today.getTime() > new Date(n.limitePago).getTime() && pagos <= 0) {
    // Caduco la solicitud y no ha hecho pagos
    check = {
      icon: 'TrendingDownIcon',
      color: 'light-warning',
      text: 'Ninguna',
    }
  } else if (pagos > 0) {
    // Ya guardó una aportación al menos
    check = {
      icon: 'TrendingUpIcon',
      color: 'light-success',
      text: `${pagos}`,
    }
  } else {
    // Está en espera
    check = {
      icon: 'ClockIcon',
      color: 'light-secondary',
      text: `(${pagos}) Aportaciones`,
    }
  }

  return check
}

/*
* Return type and color of status in transaccion
* by dny
*/
export const formTransac = [
  { 1: 'Activo', 0: 'Rechazado' }, // label
  { 1: 'light-success', 0: 'light-danger' }, // badge
  { 1: 'success', 0: 'danger' }, // timeline
]
/**
 * * pagareSts
 * @param {value} valor de status en pagare
 * @returns properties for b-badge
 */
export const pagareSts = value => {
  const status = {
    PAG: { icon: 'CheckCircleIcon', color: 'success', text: 'Pagado' },
    PND: { icon: 'AlertCircleIcon', color: 'warning', text: 'Activo' },
    CAN: { icon: 'XCircleIcon', color: 'danger', text: 'Cancelado' },
  }

  return status[value] || {}
}

export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })
  return capitalizedArray.join(' ')
}

export const avatarText = value => {
  if (!value) return ''
  const nameArray = value.split(' ')
  return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')

/**
 * * formatMoney - FORMAT FOR MONEY
 * @param {value} monto, cantidad, number etc
 * @returns $6,500.00 example
 * ! from stackoveflow
 */
export const formatMoney = value => {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
  return formatter.format(value)
}

/**
 * * smarText - FORMAT FOR TEXT
 * @param {text} string a trabajar
 * @param {length} tamaño a mostrar
 * @param {clamp} adorno para concatenar
 * @param {inverse} direction left/rigth desde donde mostrar
 */
export const smarText = (text, length, inverse = false, clamp) => {
  const clmp = clamp || '...'
  // const charge = (inverse === true) ? -20 : 0
  const node = document.createElement('div')
  node.innerHTML = text
  const content = node.textContent
  const contentCondition = (inverse === true) ? content.substring(length) : content.slice(0, length) + clmp
  return content.length > length ? contentCondition : content
}
